import { apiRequest } from './axiosConfig';

export type SamplePromptType = 'material' | 'banner';

export interface SamplePrompt {
  id: number;
  name: string;
  prompt_text: string;
  type: SamplePromptType;
  sort_order: number;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface SamplePromptCreateRequest {
  name: string;
  prompt_text: string;
  type?: SamplePromptType;
  sort_order?: number;
  is_active?: boolean;
}

export interface SamplePromptUpdateRequest {
  name: string;
  prompt_text: string;
  type?: SamplePromptType;
  sort_order?: number;
  is_active?: boolean;
}

interface SamplePromptsResponse {
  success: boolean;
  data: SamplePrompt[];
}

interface SamplePromptResponse {
  success: boolean;
  data: SamplePrompt;
  message?: string;
}

interface SamplePromptDeleteResponse {
  success: boolean;
  message: string;
}

/**
 * Admin sample prompt API service
 */
const adminSamplePromptService = {
  /**
   * Get all sample prompts
   */
  async getAll(): Promise<SamplePrompt[]> {
    const response = await apiRequest.get<SamplePromptsResponse>('admin/image-sample-prompts');
    return response.data;
  },

  /**
   * Create a new sample prompt
   */
  async create(data: SamplePromptCreateRequest): Promise<SamplePrompt> {
    const response = await apiRequest.post<SamplePromptResponse>('admin/image-sample-prompts', data);
    return response.data;
  },

  /**
   * Update a sample prompt
   */
  async update(id: number, data: SamplePromptUpdateRequest): Promise<SamplePrompt> {
    const response = await apiRequest.put<SamplePromptResponse>(`admin/image-sample-prompts/${id}`, data);
    return response.data;
  },

  /**
   * Delete a sample prompt
   */
  async delete(id: number): Promise<void> {
    await apiRequest.delete<SamplePromptDeleteResponse>(`admin/image-sample-prompts/${id}`);
  },

  /**
   * Toggle active status
   */
  async toggle(id: number): Promise<SamplePrompt> {
    const response = await apiRequest.put<SamplePromptResponse>(`admin/image-sample-prompts/${id}/toggle`);
    return response.data;
  },

  /**
   * Update sort order
   */
  async updateOrder(prompts: { id: number; sort_order: number }[]): Promise<void> {
    await apiRequest.put('admin/image-sample-prompts/order', { prompts });
  },
};

export default adminSamplePromptService;
